module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray@3x-7f734e936de2b634e19a0f64fab45aa8.png";